export default "__VITE_ASSET__LWCBBLIu__"